import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["order_id"];
import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useEffect, useState } from "react";
import { api__createOrder, api__getOrderDetailsByParams, api__getOrderWithPaymentInfo, api__getPromoCode } from "@/apis/orders/orders";
import ReservedPostException from "@/exceptions/postExceptions/ReservedPostException";
import useHelpers from "@hooks/useHelpers";
import { dispatchButtonLoading } from "@hooks/useButtonLoading";
import { ValidationException } from "@/common/exceptions/ValidationException";
import { normalizeIdNumber } from "@/utils/stringHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import useBoolean from "@hooks/useBoolean";
export var PURCHASE_METHOD_CASH = "cash";
export var PURCHASE_METHOD_NORMAL_FINANCE = "normal_finance";
export var PURCHASE_METHOD_TAMRA = "tamra";
export var PURCHASE_METHOD_ARIB = "arib";
export var PURCHASE_METHOD_TABBY = "tabby";
export var PURCHASE_METHOD_AMWAL = "amwaal";
var extractQueryParams = function extractQueryParams() {
  var _searchParams$get, _searchParams$get2;
  var searchParams = new URLSearchParams(__IS_CSR__ ? window.location.search : "");
  var post_id = Number(searchParams.get('post_id')) || Number(searchParams.get('postId'));
  var order_id = normalizeIdNumber(searchParams.get("id"));
  if (!order_id) {
    order_id = normalizeIdNumber(searchParams.get("order_id"));
  }
  var is_test_order = ((_searchParams$get = searchParams.get("id")) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.includes("test")) || ((_searchParams$get2 = searchParams.get("order_id")) === null || _searchParams$get2 === void 0 ? void 0 : _searchParams$get2.includes("test"));
  var customerid = searchParams.get('customerid');
  var referral = searchParams.get('referral');
  var hasTawuniyaParams = customerid && referral;
  return {
    order_id: order_id,
    post_id: post_id,
    is_test_order: is_test_order,
    hasTawuniyaParams: hasTawuniyaParams,
    customerid: customerid,
    referral: referral
  };
};
var getFormDataDefault = function getFormDataDefault(user, checkoutOrder) {
  return {
    full_name: (user === null || user === void 0 ? void 0 : user.full_name) || "",
    city_id: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.city_id) || null,
    phone_number: (user === null || user === void 0 ? void 0 : user.phone_number) || "",
    whatsapp_optin: 1,
    code: null
  };
};
// SE-11902: persist promo/referral/warranty across CheckoutOrderContextProvider remount (browser back)
var CHECKOUT_PERSIST_PREFIX = "checkout_persist_";
var getCheckoutPersistKey = function getCheckoutPersistKey() {
  if (typeof window === "undefined") return null;
  var post_id = extractQueryParams().post_id;
  return post_id ? "".concat(CHECKOUT_PERSIST_PREFIX).concat(post_id) : null;
};

// SE-11902: only the shop-apply page owns the promo/warranty form — other pages (e.g. create-araboon)
// reuse the same context and must not overwrite the stored values when they mount with empty form state.
var isShopApplyPage = function isShopApplyPage() {
  return typeof window !== "undefined" && window.location.pathname.includes("/checkout/shop-apply");
};
var readPersistedCheckout = function readPersistedCheckout() {
  try {
    var key = getCheckoutPersistKey();
    if (!key) return {};
    var raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : {};
  } catch (_unused) {
    return {};
  }
};
var writePersistedCheckout = function writePersistedCheckout(data) {
  try {
    if (!isShopApplyPage()) return;
    var key = getCheckoutPersistKey();
    if (!key) return;
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch (_unused2) {
    // ignore storage errors
  }
};
var CheckoutOrderContext = /*#__PURE__*/createContext(null);
export function useCheckoutOrder() {
  return useContext(CheckoutOrderContext);
}
export default function CheckoutOrderContextProvider(_ref) {
  var _readPersistedCheckou;
  var children = _ref.children;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var location = useLocation();
  var _useSession = useSession(),
    user = _useSession.user;
  var _useState = useState(extractQueryParams()),
    queryParams = _useState[0],
    setQueryParams = _useState[1];
  var _useState2 = useState((_readPersistedCheckou = readPersistedCheckout().referralData) !== null && _readPersistedCheckou !== void 0 ? _readPersistedCheckou : null),
    referralData = _useState2[0],
    setReferralData = _useState2[1];
  var _useState3 = useState(),
    checkoutOrder = _useState3[0],
    setCheckoutOrder = _useState3[1];
  var _useState4 = useState(false),
    fetch_loading = _useState4[0],
    setFetch_loading = _useState4[1];
  var _useState5 = useState(null),
    fetching_error = _useState5[0],
    setFetching_error = _useState5[1];
  var _useState6 = useState(null),
    formValidationException = _useState6[0],
    setFormValidationException = _useState6[1];
  var _useState7 = useState(""),
    purchaseMethod = _useState7[0],
    setPurchaseMethod = _useState7[1];
  var _useState8 = useState(null),
    showCampaignModal = _useState8[0],
    setShowCampaignModal = _useState8[1];
  var _useState9 = useState(false),
    showStory = _useState9[0],
    setShowStory = _useState9[1];
  var _useState0 = useState(function () {
      var base = getFormDataDefault(user);
      var persisted = readPersistedCheckout();
      console.log('we here', persisted);
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, base), persisted.code != null ? {
        code: persisted.code
      } : {}), persisted.v_warranty_id != null ? {
        v_warranty_id: persisted.v_warranty_id
      } : {}), persisted.full_name != null ? {
        full_name: persisted.full_name
      } : {}), persisted.city_id != null ? {
        city_id: persisted.city_id
      } : {});
    }),
    formData = _useState0[0],
    setFormData = _useState0[1];

  // SE-11902: keep promo/referral/warranty in sessionStorage so back button restores them after remount
  useEffect(function () {
    var _formData$code, _formData$v_warranty_, _formData$full_name, _formData$city_id;
    writePersistedCheckout({
      code: (_formData$code = formData === null || formData === void 0 ? void 0 : formData.code) !== null && _formData$code !== void 0 ? _formData$code : null,
      v_warranty_id: (_formData$v_warranty_ = formData === null || formData === void 0 ? void 0 : formData.v_warranty_id) !== null && _formData$v_warranty_ !== void 0 ? _formData$v_warranty_ : null,
      full_name: (_formData$full_name = formData === null || formData === void 0 ? void 0 : formData.full_name) !== null && _formData$full_name !== void 0 ? _formData$full_name : null,
      city_id: (_formData$city_id = formData === null || formData === void 0 ? void 0 : formData.city_id) !== null && _formData$city_id !== void 0 ? _formData$city_id : null,
      referralData: referralData
    });
  }, [formData === null || formData === void 0 ? void 0 : formData.code, formData === null || formData === void 0 ? void 0 : formData.v_warranty_id, formData === null || formData === void 0 ? void 0 : formData.full_name, formData === null || formData === void 0 ? void 0 : formData.city_id, referralData]);

  // SE-11902: the provider instance is shared across shop-apply <-> create-araboon and is NOT
  // remounted on SPA back navigation, so the constructor-time restore (useState) does not re-run.
  // Re-hydrate from sessionStorage whenever we land back on the shop-apply page.
  useEffect(function () {
    if (!isShopApplyPage()) return;
    var persisted = readPersistedCheckout();
    if (persisted.referralData) setReferralData(persisted.referralData);
    if (persisted.code != null || persisted.v_warranty_id != null || persisted.full_name != null || persisted.city_id != null) {
      setFormData(function (prev) {
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, prev), persisted.code != null ? {
          code: persisted.code
        } : {}), persisted.v_warranty_id != null ? {
          v_warranty_id: persisted.v_warranty_id
        } : {}), persisted.full_name != null ? {
          full_name: persisted.full_name
        } : {}), persisted.city_id != null ? {
          city_id: persisted.city_id
        } : {});
      });
      // refresh pricing with the restored promo/warranty (mount-fetch does not re-run on SPA back)
      fetch__getOrderDetailsByParams(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, persisted.code != null ? {
        code: persisted.code
      } : {}), persisted.v_warranty_id != null ? {
        v_warranty_id: persisted.v_warranty_id
      } : {}), persisted.full_name != null ? {
        full_name: persisted.full_name
      } : {}), persisted.city_id != null ? {
        city_id: persisted.city_id
      } : {}));
    }
  }, [location.pathname]);
  var financeModal = useBoolean();
  var action__initFormData = function action__initFormData() {
    var _persisted$referralDa;
    setQueryParams(extractQueryParams());
    var persisted = readPersistedCheckout();
    setFormData(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getFormDataDefault(user, checkoutOrder)), persisted.code != null ? {
      code: persisted.code
    } : {}), persisted.v_warranty_id != null ? {
      v_warranty_id: persisted.v_warranty_id
    } : {}), persisted.full_name != null ? {
      full_name: persisted.full_name
    } : {}), persisted.city_id != null ? {
      city_id: persisted.city_id
    } : {}));
    setReferralData((_persisted$referralDa = persisted.referralData) !== null && _persisted$referralDa !== void 0 ? _persisted$referralDa : null);
    setFormValidationException(null);
    setFetching_error(null);
  };
  var action__setPurchaseMethod = function action__setPurchaseMethod(method) {
    setPurchaseMethod(method);
  };
  var action__setShowCampaignModal = function action__setShowCampaignModal(value) {
    setShowCampaignModal(value);
  };
  var action__setShowStory = function action__setShowStory(value) {
    setShowStory(value);
  };
  useEffect(function () {
    if (queryParams !== null && queryParams !== void 0 && queryParams.post_id) {
      fetch__getOrderDetailsByParams({
        code: formData.code
      }).then(console.log);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.city_id, queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id]);
  useEffect(function () {
    if (checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.referral_code && !formData.code) {
      setFormItem('code', checkoutOrder.referral_code);
      fetch__getPromoCode(checkoutOrder.referral_code);
    }
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.referral_code]);
  useEffect(function () {
    setQueryParams(extractQueryParams());
  }, [location]);
  var setFormItem = function setFormItem(key, value) {
    setFormData(_objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, key, value)));
  };
  var action__resetPromoCode = function action__resetPromoCode() {
    setFormItem('code', null);
    setReferralData(null);
    fetch__getOrderDetailsByParams(_objectSpread({
      code: null
    }, formData.v_warranty_id != null && {
      v_warranty_id: formData.v_warranty_id
    }));
  };
  var fetch__getOrderDetailsByParams = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var override,
        _omitOrderId,
        queryParamsWithoutOrderId,
        params,
        order,
        _args = arguments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            override = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            // SE-11902: get-details by-params is pre-order (cash/shop-apply) — must not send a committed order_id
            // SE-11902: only shop-apply (pre-order, cash) must not send a committed order_id;
            // order-based pages (create-araboon, etc.) still need it for get-details.
            _omitOrderId = queryParams.order_id, queryParamsWithoutOrderId = _objectWithoutProperties(queryParams, _excluded);
            params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, isShopApplyPage() ? queryParamsWithoutOrderId : queryParams), !referralData || !referralData.valid ? {
              code: ''
            } : {}), formData), {}, {
              post_id: queryParams.post_id
            }, override);
            setFetch_loading(true);
            _context.p = 1;
            _context.n = 2;
            return api__getOrderDetailsByParams(params);
          case 2:
            order = _context.v;
            setCheckoutOrder(order);
          case 3:
            _context.p = 3;
            setFetch_loading(false);
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1,, 3, 4]]);
    }));
    return function fetch__getOrderDetailsByParams() {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetch__getOrderWithPaymentInfo = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(post_id, order_id) {
      var order, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            setFetch_loading(true);
            _context2.n = 1;
            return api__getOrderWithPaymentInfo(user === null || user === void 0 ? void 0 : user.id, order_id, post_id);
          case 1:
            order = _context2.v;
            setCheckoutOrder(order);
            _context2.n = 4;
            break;
          case 2:
            _context2.p = 2;
            _t = _context2.v;
            if (!(_t instanceof ReservedPostException)) {
              _context2.n = 3;
              break;
            }
            return _context2.a(2, navigateTo("/cardetail/".concat(_t.post_id, "?ref=car_reserved")));
          case 3:
            setFetching_error(_t);
          case 4:
            _context2.p = 4;
            setFetch_loading(false);
            return _context2.f(4);
          case 5:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2, 4, 5]]);
    }));
    return function fetch__getOrderWithPaymentInfo(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var fetch__getPromoCode = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(code) {
      var promData, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            setFetch_loading(true);
            _context3.n = 1;
            return api__getPromoCode({
              code: code,
              post_id: queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id,
              city_id: (formData === null || formData === void 0 ? void 0 : formData.city_id) || null
            });
          case 1:
            promData = _context3.v;
            setReferralData(promData);
            return _context3.a(2, promData);
          case 2:
            _context3.p = 2;
            _t2 = _context3.v;
            setFetching_error(_t2);
          case 3:
            _context3.p = 3;
            setFetch_loading(false);
            return _context3.f(3);
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2, 3, 4]]);
    }));
    return function fetch__getPromoCode(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var fetch__createOrder = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var toBeSendParams, newOrder, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            toBeSendParams = _objectSpread(_objectSpread(_objectSpread({}, queryParams), formData), {}, {
              examine_date: ''
            });
            delete toBeSendParams["code"];
            if (referralData && referralData.valid) {
              toBeSendParams["referral_code_id"] = referralData.referral_code_id;
            }
            dispatchButtonLoading(true);
            _context4.p = 1;
            _context4.n = 2;
            return api__createOrder(toBeSendParams);
          case 2:
            newOrder = _context4.v;
            setCheckoutOrder(newOrder);
            return _context4.a(2, newOrder);
          case 3:
            _context4.p = 3;
            _t3 = _context4.v;
            if (!(_t3 instanceof ValidationException)) {
              _context4.n = 4;
              break;
            }
            return _context4.a(2, setFormValidationException(_t3));
          case 4:
            console.log('error', _t3);
            toast.error(_t3.message);
            throw _t3;
          case 5:
            _context4.p = 5;
            dispatchButtonLoading(false);
            return _context4.f(5);
          case 6:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3, 5, 6]]);
    }));
    return function fetch__createOrder() {
      return _ref5.apply(this, arguments);
    };
  }();

  /** Collections **/
  var actions = {
    setCheckoutOrder: setCheckoutOrder,
    setFormItem: setFormItem,
    action__resetPromoCode: action__resetPromoCode,
    action__initFormData: action__initFormData,
    action__setPurchaseMethod: action__setPurchaseMethod,
    action__setShowCampaignModal: action__setShowCampaignModal,
    action__setShowStory: action__setShowStory
  };
  var remote_actions = {
    fetch__getOrderWithPaymentInfo: fetch__getOrderWithPaymentInfo,
    fetch__getOrderDetailsByParams: fetch__getOrderDetailsByParams,
    fetch__getPromoCode: fetch__getPromoCode,
    fetch__createOrder: fetch__createOrder
  };
  var state = {
    checkoutOrder: checkoutOrder,
    fetch_loading: fetch_loading,
    fetching_error: fetching_error,
    formData: formData,
    referralData: referralData,
    formValidationException: formValidationException,
    purchaseMethod: purchaseMethod,
    showCampaignModal: showCampaignModal,
    showStory: showStory,
    financeModal: financeModal
  };
  return /*#__PURE__*/React.createElement(CheckoutOrderContext.Provider, {
    value: {
      actions: actions,
      remote_actions: remote_actions,
      state: state,
      queryParams: queryParams
    }
  }, children);
}